/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { setCypressID } from 'src/utils/setCypressID';
import { NavbarTestID, ZILLOW_NAVBAR_STATIC_TEST_IDS } from '../../constants';
import { HamburgerButton } from './components/ZillowNavbarHamburgerButton';
import { ZillowNavbarHamburgerBox } from './components/ZillowNavbarHamburgerBox';
import { HamburgerProps } from './types';
import { ZillowNavbarHamburgerInner } from './components/ZillowNavbarHamburgerInner';

export const ZillowNavbarHamburger: FunctionComponent<HamburgerProps> = ({ isMobileNavOpen, version, onClick }) => (
    <HamburgerButton
        onClick={onClick}
        {...setCypressID(new NavbarTestID(ZILLOW_NAVBAR_STATIC_TEST_IDS.HAMBURGER).id)}
        className="hamburger"
        type="button"
        aria-label={isMobileNavOpen ? 'Close navigation' : 'Open navigation'}>
        <ZillowNavbarHamburgerBox>
            <ZillowNavbarHamburgerInner version={version} isMobileNavOpen={isMobileNavOpen} />
        </ZillowNavbarHamburgerBox>
    </HamburgerButton>
);
